import { render, staticRenderFns } from "./facilityobjectsinfo.vue?vue&type=template&id=386afbf9&"
import script from "./facilityobjectsinfo.vue?vue&type=script&lang=js&"
export * from "./facilityobjectsinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386afbf9')) {
      api.createRecord('386afbf9', component.options)
    } else {
      api.reload('386afbf9', component.options)
    }
    module.hot.accept("./facilityobjectsinfo.vue?vue&type=template&id=386afbf9&", function () {
      api.rerender('386afbf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29xNSSoVRk0Zr/JS/facilityobjectsinfo.vue"
export default component.exports